// extracted by mini-css-extract-plugin
export default {"parent":"app-portainer-components-NavTabs-NavTabs-module__parent"};